import { IconButton, Stack, styled } from '@mui/material'
import { CloseIcon } from '$common/icons/close'
import { CulturalContents } from '../cultural-contents'
import { WritingTools } from '../writing-tools'
import { UsefulTools } from '../usefull-tools'
import { ConnectivityTools } from '../connectivity-tools'
import {
  showToolboxCommunicationToolsModal,
  showToolboxCulturalContentsModal,
} from '$comp/modals/toolbox'

const Root = styled(Stack)`
  padding: 0 15px;
  align-items: center;
`
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  width: '54px',
  height: '54px',
  margin: '20px 0 !important',
  '&:hover': {
    backgroundColor: theme.palette.error.main,
  },
}))

interface Props {
  onClose?: () => void
}

export function NavigationBarToolBoxHome({ onClose }: Props) {
  return (
    <Root spacing={1.5}>
      <CulturalContents onClick={() => showToolboxCulturalContentsModal()} />
      <Stack
        sx={{ width: '100%' }}
        direction="row"
        justifyContent="space-between"
      >
        <WritingTools />
        <UsefulTools />
      </Stack>
      <ConnectivityTools onClick={() => showToolboxCommunicationToolsModal()} />
      <StyledIconButton onClick={onClose}>
        <CloseIcon />
      </StyledIconButton>
    </Root>
  )
}

NavigationBarToolBoxHome.defaultProps = {
  onClose: () => {
    //
  },
}
